module.exports = __webpack_public_path__ + "media/images/scout_office-25f41d35.jpeg";